<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="100px" class="demo-form-inline ">
        <el-form-item label="锁定数据" prop="lockData">
          <el-input v-model="form.lockData" placeholder="请输入锁定数据"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="form.state" clearable filterable placeholder="请选择状态">
            <el-option
              label="正常"
              value="0" >
            </el-option>
            <el-option
              label="锁定"
              value="1" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="锁定数据"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.lockData }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="锁定时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="锁定时长(h)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.lockDuration }}</span>
          </template>
        </el-table-column>
        <el-table-column width="190" fixed="right" label="操作" >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.locked"
              active-value="0"
              inactive-value="1"
              @change="changeStatus(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'registeredUser',
  data () {
    return {
      form: {
        lockData: '',
        locked: ''
      },
      cusDialog: false,
      tableData: [],
      detailForm: {},
      tooltip: true,
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.lockData = ''
      this.form.state = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    changeStatus (index, value) {
      console.log(value)
      if (value.locked === '1') {
        value.locked = '0'
        let params = {
          lockId: value.lockId,
          locked: 1
        }
        this.$confirm('锁定后，将不允许使用获取验证码功能，请确认是否锁定数据?', '验证码功能锁定', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(_self.$API.rechargeManagement.lockGetCode, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '锁定成功'
                })
                _self.query()
              })
              .catch(function (error) { console.log(error) })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      } else {
        value.locked = '1'
        let params = {
          lockId: value.lockId,
          locked: 0
        }
        this.$confirm('解锁后，将允许使用获取验证码功能，请确认是否解锁数据?', '验证码功能解锁', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let _self = this
            this.$axios
              .post(_self.$API.rechargeManagement.lockGetCode, params)
              .then(function (r) {
                _self.$message({
                  type: 'success',
                  message: '解锁成功'
                })
                _self.query()
              })
              .catch(function (error) { console.log(error) })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      }
    },
    query () {
      let op = {}
      let _this = this
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.lockData = this.form.lockData
      op.locked = this.form.state
      this.$axios({
        url: _this.$API.rechargeManagement.queryLockLogByPage,
        // url: 'http://172.16.9.132:5010/agw/lockLog/queryLockLogByPage',
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userManagement/userCodeManager.vue